import { render } from "./LbrxCashDrawer.vue?vue&type=template&id=1215c77f"
import script from "./LbrxCashDrawer.vue?vue&type=script&lang=js"
export * from "./LbrxCashDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__